/**
 * Verifica se o navegador suporta a reprodução de vídeo HTML5
 */
export const supportsHTML5Video = () => {
  try {
    const videoElement = document.createElement('video');
    return !!videoElement.canPlayType;
  } catch (e) {
    return false;
  }
};

/**
 * Verifica se o navegador suporta HLS (HTTP Live Streaming)
 */
export const supportsHLS = () => {
  try {
    if (!supportsHTML5Video()) return false;
    
    const videoElement = document.createElement('video');
    return (
      videoElement.canPlayType('application/vnd.apple.mpegurl') !== '' ||
      videoElement.canPlayType('application/x-mpegURL') !== ''
    );
  } catch (e) {
    return false;
  }
};

/**
 * Verifica se o navegador suporta MPEG-DASH
 */
export const supportsDASH = () => {
  try {
    if (!supportsHTML5Video()) return false;
    
    const videoElement = document.createElement('video');
    return videoElement.canPlayType('application/dash+xml') !== '';
  } catch (e) {
    return false;
  }
};

/**
 * Retorna os formatos de vídeo suportados pelo navegador
 */
export const getSupportedFormats = () => {
  try {
    if (!supportsHTML5Video()) return [];
    
    const videoElement = document.createElement('video');
    const formats = [];
    
    // Verifica MPEG-4/H.264
    if (videoElement.canPlayType('video/mp4; codecs="avc1.42E01E"') !== '') {
      formats.push('mp4');
    }
    
    // Verifica HLS
    if (supportsHLS()) {
      formats.push('m3u8');
    }
    
    // Verifica WebM
    if (videoElement.canPlayType('video/webm; codecs="vp8, vorbis"') !== '') {
      formats.push('webm');
    }
    
    // Verifica Ogg/Theora
    if (videoElement.canPlayType('video/ogg; codecs="theora, vorbis"') !== '') {
      formats.push('ogg');
    }
    
    // Adiciona TS como opção padrão para IPTV
    formats.push('ts');
    
    return formats;
  } catch (e) {
    console.error('Erro ao verificar formatos suportados:', e);
    return ['ts', 'm3u8', 'mp4']; // Formatos padrão em caso de erro
  }
};

export default {
  supportsHTML5Video,
  supportsHLS,
  supportsDASH,
  getSupportedFormats
}; 